let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7KxtP")).then(() => parcelRequire('ggsqD'));